module.exports = __webpack_public_path__ + "img/frequency.119f4822.png";